import React, { ReactNode } from "react";

import { faExternalLinkAlt } from "@fortawesome/pro-solid-svg-icons/faExternalLinkAlt";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useIntl } from "react-intl";

import info from "@app/assets/frequency/info.svg";
import ButtonLink from "@app/component/ButtonLink";
import HelpText from "@app/component/typography/HelpText";

import styles from "./Info.module.scss";

interface Props {
  hideText?: boolean;
}

const FrequencyInfo = ({ hideText }: Props) => {
  const intl = useIntl();

  return (
    <HelpText
      info={
        <div className={styles.popover}>
          <div>
            <div className={styles.title}>
              {intl.formatMessage({
                id: "frequency.cadenceSelector.popover.title",
                defaultMessage: "Frequencies",
                description: "frequency component - info - Frequencies - popover",
              })}
            </div>
            <div className={styles.text}>
              {intl.formatMessage(
                {
                  id: "frequency.cadenceSelector.popover.text",
                  defaultMessage:
                    "Opt into Frequencies to <b>prevent any accounts from being overlooked.</b> The frequency status will be highlighted on each record, and we'll provide clear guidance on how to get an account back on track.",
                  description: "frequency component - Frequencies - text - text",
                },
                { b: (text: ReactNode) => <b>{text}</b> }
              )}
            </div>
            <ButtonLink
              className={styles.link}
              href="https://hs.mapmycustomers.me/en/support/frequencies-1"
              target="_blank"
            >
              {intl.formatMessage(
                {
                  id: "frequency.cadenceSelector.popover.link",
                  defaultMessage: "More about Frequencies",
                  description: "frequency component - Frequencies - link",
                },
                { b: (text: ReactNode) => <b>{text}</b> }
              )}
              <FontAwesomeIcon className={styles.externalLinkIcon} icon={faExternalLinkAlt} />
            </ButtonLink>
          </div>
          <img alt="info" src={info} />
        </div>
      }
      text={
        hideText
          ? undefined
          : intl.formatMessage({
              id: "frequency.cadenceSelector.info.text",
              defaultMessage: "What are frequencies?",
              description: "frequency component - info - text",
            })
      }
    />
  );
};

export default FrequencyInfo;
